<template>
  <div class="w-full h-full flex flex-col bg-white">
    <div class="flex-1 min-h-0">
      <PaymePaymentForm
        :paymentUuid="paymentUuid"
        :maxInstallments="12"
        :showWallet="false"
        @completed="onCompleted" />
    </div>
    <div class="flex-none px-4 pb-4">
      <Button label="ביטול" severity="secondary" text class="w-full" @click="router.back()" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import { PaymePaymentForm } from '@torim-app/shared-components';
import { useAdminHomeStore, useAdminStore } from '@app/stores';
import { AdminRouteNames } from '@app/router/route-names';

// The manual (card-present) charge as a page of its own, used by the iOS app: PayMe's card
// fields take no touches there while the drawers are open, so the payment sheet closes them
// and comes here instead.
const route = useRoute();
const router = useRouter();
const adminStore = useAdminStore();
const adminHomeStore = useAdminHomeStore();
adminStore.setPage(AdminRouteNames.ManualCardCharge);

const paymentUuid = route.params.uuid as string;

const onCompleted = () => {
  // The appointment's paid state shows on the calendar.
  adminHomeStore.fetchBusinessCalendarDataSilently();
  router.back();
};
</script>
